require('./compliance-framework.module.js');
require('./compliance-framework.route.js');

require('./account');
require('./account_users');
require('./audit_events');
require('./banners');
require('./components');
require('./dashboard');
require('./fis');
require('./help');
require('./landing');
require('./layouts');
require('./login');
require('./notifications');
require('./orders');
require('./password_resets');
require('./profile');
require('./services');
require('./staff');
require('./mass_email');
//require('./training_center');
//require('./training_resources');
require('./users');
